import React, { useState, useEffect, Fragment } from 'react';
import {
    makeStyles,
    withStyles,
    Typography,
    Slide as MUISlide,
    Dialog,
    IconButton,
    DialogContent,
    DialogActions,
    Button,
    DialogTitle,
    Divider,
    DialogContentText,
    Card,
    CardContent,
    FormHelperText,
    Collapse,
    Menu,
    MenuList,
    ClickAwayListener,
    Grow,
    Popper,
    InputAdornment,
    Grid
} from "@material-ui/core";
import { addExpenseDialogCss } from './VehicleDialogCss';
import CloseIcon from '@material-ui/icons/Close';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
} from 'mui-rff';
import { Form, Field } from 'react-final-form';
import { connect } from "react-redux";
import DateFnsUtils from '@date-io/date-fns';
import { OnChange } from 'react-final-form-listeners';
import DriverNameSelect from '../DriverDialogs/DriverNameSelect';
import { getTripDateFilterValues, isEmpty, numberWithCommas, replaceCommas, checkNumberOnly } from '../../../utils/utils';
import { updateVehicle3, singleTruck, PandL, Expenses, UpdateExpenseDetails, DeletePhotoAttachments } from '../../../store/actions/vehicleActionCreator';
import * as logger from '../../../logger';
import { addVendorExpense, addExpenseV1, editExpenseV1 } from '../../../store/actions/tripActionCreator';
import S3Uploader from '../s3Uploader/s3Uploader';
import AmountInput from '../Inputs/AmountInput';
import { trackDwebEvent } from '../../analytics';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import { defaultPageNo, defaultPageSize, defaultDebounceMs } from '../../../paginationVariables';
import { debounce } from 'lodash';
import { Waypoint } from "react-waypoint";
import AddShop from '../../pages/Shops/AddShop';
import { shopListForSelection } from '../../../store/actions/userActionCreators';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { ExpenseTypeReceiptIcon, AddPersonIcon } from '../../../components/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const AddFuelExpenseDialog = ({ open, onClose, edit, dispatchPhotoAttachmentDelete, vehicle, dispatchUpdateVehicleNew, dispatchUpdateExpenseDetails, dispatchGetSingleTruck, dispatchGetPandL, dispatchGetTripExpenses, user, onConfirm, dispacthAddExpenses, fuelExpenseData,
    dispatchAddExpenseV1,
    dispatchEditExpenseV1,
    dispatchGetShopList,
    expenseId,
    requestData,
    fromSingleTrip,
    journey,
    selectedTrip,
    updateJourney
}) => {
    let submit;
    const [dialogOpen, setDialogOpen] = useState(open);
    const [formError, setFormError] = React.useState(false);
    const [addDriverDialog, setAddDriverDialog] = useState(false);
    const [paidByDriverValue, setPaidByDriverValue] = useState(false);
    const [addExpensePhoto, setAddExpensePhoto] = useState([]);

    const [paymentType, setPaymentType] = useState("Cash");
    const [paymentError, setPaymentError] = useState(null);


    const [fuelQuantityValue, setFuelQuantityValue] = useState("");
    const [expenseAmountValue, setExpenseAmountValue] = useState("");
    const [ratePerLitreValue, setRatePerLitreValue] = useState("");
    const [driverNameValue, setDriverNameValue] = useState("");

    const classes = addExpenseDialogCss();

    useEffect(() => {

        if (fuelExpenseData) {
            setExpenseAmountValue(numberWithCommas(fuelExpenseData.amount));
            setFuelQuantityValue(fuelExpenseData.fuelQuantity);
            setRatePerLitreValue(fuelExpenseData.ratePerLitre);
            setPaymentType(fuelExpenseData.paymentMethod);
            setAddExpensePhoto(fuelExpenseData.attachments ? fuelExpenseData.attachments : []);
            setPaidByDriverValue(fuelExpenseData.paidByDriver);
            if (fuelExpenseData.paymentMethod) {
                setExpensePaymentMethod(fuelExpenseData.paymentMethod)
            }
            if (fuelExpenseData.paymentMethod && fuelExpenseData.paymentMethod == 'credit' && fuelExpenseData.shopId && fuelExpenseData.shopName) {
                setExpenseShop({
                    id: fuelExpenseData.shopId,
                    name: fuelExpenseData.shopName
                })
            }
            if (fuelExpenseData.paymentMethod && fuelExpenseData.paymentMethod == 'online' && fuelExpenseData.paymentData) {
                setExpenseTransactionId(fuelExpenseData.paymentData)
            }
        }
    }, [open, fuelExpenseData])

    const [expensePaymentMethod, setExpensePaymentMethod] = React.useState('cash');
    const [expenseTransactionId, setExpenseTransactionId] = React.useState('');
    const [shopsListData, setShopsListData] = React.useState(null);
    const [shops, setShops] = React.useState([]);
    const [expenseShop, setExpenseShop] = React.useState(null);
    const [shopInputValue, setShopInputValue] = React.useState('');
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [addShopOpen, toggleAddShopOpen] = React.useState(false);
    const [shopDialogValue, setShopDialogValue] = React.useState({
        name: ''
    });
    const handleAddShopClose = () => {
        setShopDialogValue({
            name: '',
        });
        toggleAddShopOpen(false);
    };
    const handleShopSave = (status, response) => {
        toggleAddShopOpen(false);
        fetchShops()
        setExpenseShop(response && response.id ? response : null);
    }
    const onSearchBlur = debounce(query => {
        setCurrentPageNo(defaultPageNo)
        fetchShops(query, false)
    }, user && user.configs && user.configs.dwebSearchBebounceMs ? parseInt(user.configs.dwebSearchBebounceMs) : defaultDebounceMs);
    const fetchShops = (search, pagination) => {
        let req = {
            pageSize: defaultPageSize,
            pageNo: defaultPageNo,
        }
        if (pagination) {
            req.pageNo = currentPageNo + 1
        }
        if (search) {
            req.search = search;
        }
        dispatchGetShopList(req, (res) => {
            if (res && res.status && res.status.code && res.status.code == 200 && res.response) {
                setShopsListData(res.response)
                if (pagination) {
                    setShops([...shops, ...res.response.shops])
                } else {
                    setShops(res.response.shops)
                }
            }
        }, () => {

        })
    }
    useEffect(() => {
        let active = true;
        if (shopInputValue === '') {
            return undefined;
        }
        return () => {
            active = false
        }
    }, [shopInputValue])
    useEffect(() => {
        if (expensePaymentMethod && expensePaymentMethod == 'credit') {
            //fetchShops()
        }
        if (expensePaymentMethod && expensePaymentMethod == 'paid_by_driver') {
            /*if (!driverVal) {
              handleDriverSelectOpen(true);
            }*/
            handlePaidByDriver()
        }
    }, [expensePaymentMethod])

    let singleTruck = vehicle.singleTruck;
    let truckBook = vehicle.truckBooks;

    let initialValues = {
        paidByDriver: paidByDriverValue,
        paymentMethod: paymentType ? paymentType : 'Cash',
        amount: expenseAmountValue,
        fuelQuantity: fuelQuantityValue,
        ratePerLitre: ratePerLitreValue,
        filledFullTank: fuelExpenseData ? fuelExpenseData.isTankFilled : false,
        kmReading: fuelExpenseData && fuelExpenseData.kmReading ? fuelExpenseData.kmReading : "",
        expenseDate: fuelExpenseData && fuelExpenseData.expenseDate ? new Date(fuelExpenseData.expenseDate * 1000) : new Date(),
        dieselPumpName: fuelExpenseData && fuelExpenseData.bunkName ? fuelExpenseData.bunkName : "",
        paymentMethod: expensePaymentMethod,
        transactionId: expenseTransactionId,
        shop: expenseShop,
    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const onSubmit = values => {

        const fleetOwnerIdValue = user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "";

        let attach = [];

        let {
            paymentMethod,
            shop,
            transactionId
        } = values;

        addExpensePhoto.map((link) => {
            if (link.id) {
                attach.push({ s3Link: link.s3Link, id: link.id });
            } else {
                attach.push({ s3Link: link.s3Link });
            }
        })

        let expenseData = {
            vehicleId: "",
            fleetOwnerId: fleetOwnerIdValue,
            amount: replaceCommas(values.amount),
            fuelQuantity: values.fuelQuantity,
            ratePerLitre: replaceCommas(values.ratePerLitre),
            kmReading: values.kmReading,
            isTankFilled: values.filledFullTank,
            paymentMethod: paymentType,
            expenseDate: Math.round((values.expenseDate.setHours(0, 0, 0, 0) / 1000)),
            bunkName: values.dieselPumpName,
            attachments: attach,
            type: "Fuel_Expense",
            expenseParentType: "fuel",
            paidByDriver: values.paidByDriver,
            paymentMethod: paymentMethod
        };

        if (fromSingleTrip && journey && journey.id) {
            expenseData.vehicleId = journey && journey.vehicle && journey.vehicle.vehicleId ? journey.vehicle.vehicleId : ""
            expenseData.journeyId = journey && journey.id ? journey.id : ""
        }else if (fromSingleTrip) {
            expenseData.vehicleId = requestData && requestData.vehicleId ? requestData.vehicleId : ""
            expenseData.tripId = requestData && requestData.tripId ? requestData.tripId : ""
        } else {
            expenseData.vehicleId = singleTruck && singleTruck.id ? singleTruck.id : ""
        }

        if (paymentMethod && paymentMethod == 'online' && transactionId) {
            expenseData['paymentData'] = transactionId;
        }
        if (paymentMethod && paymentMethod == 'paid_by_driver') {
            expenseData['paidByDriver'] = true;
        }
        if (paymentMethod && paymentMethod == 'credit' && shop && shop.id) {
            expenseData['shopId'] = shop.id;
        } else {
            expenseData['shopId'] = null;
        }
        if (edit) {

            dispatchEditExpenseV1(
                expenseId,
                expenseData,
                (data) => {
                    if (data.status && data.status.code == 200) {
                        logger.log("Add Fuel Expense Dialog Dweb", "Update expense successfull");
                        setDialogOpen(false);
                        onConfirm();
                    }
                },
                () => {
                    logger.log("Add Fuel Expense Dialog Dweb", "Update expense failed");
                }
            );

        } else {
            dispatchAddExpenseV1(expenseData,
                (data) => {
                    if (data.status && data.status.code == 200) {
                        trackDwebEvent("Dweb SVP Fuel Book Expense Created Successfull", {
                            vehicle_id: data && data.response && data.response.vehicleId ? data.response.vehicleId : "",
                            vehicle_number: truckBook.vehicleNumber ? truckBook.vehicleNumber : "",
                            total_fuel_expense: truckBook.totalCost ? truckBook.totalCost : "",
                            expense_amount: data && data.response && data.response.amount ? data.response.amount : "",
                            expense_id: data && data.response && data.response.id ? data.response.id : "",
                        });
                        logger.log("Single Vehicle Add Fuel Dialog", "Add expense successfull");
                        setDialogOpen(false);
                        onConfirm();
                    }
                },
                () => {
                    logger.log("Single Vehicle Add Fuel Dialog", "Add expense failed");
                }
            );
        }
    }

    const validate = values => {

        let errors = {};
        if (values) {
            if (errors.noValues) {
                delete errors['noValues'];
            }
            if (!values.amount || !checkNumberOnly(replaceCommas(values.amount))) {
                errors.amount = "Please enter the amount";
            }
            if (!values.expenseDate) {
                errors.expenseDate = "Please select date"
            }
            if (!values.paymentMethod || paymentType == "") {
                errors.paymentMethod = "Please select the payment method"
                setPaymentError(true);
            } else {
                setPaymentError(false);
            }
            if (values && values.paymentMethod && values.paymentMethod == 'credit' && !values.shop) {
                errors.shop = 'Please Select a shop';
            }
        } else {
            errors.noValues = "novalues"
        }
        return errors;

    }

    const handlePaidByDriver = (value) => {

        setPaidByDriverValue(!paidByDriverValue);

        if (fromSingleTrip && requestData && requestData.driverId && !paidByDriverValue) {
            setDriverNameValue({ name: requestData.driverName, id: requestData.driverId })
        } else if (!singleTruck.driverId && !paidByDriverValue) {
            setAddDriverDialog(true);
            setDriverNameValue("");
        }
        else if (singleTruck.driverId && !paidByDriverValue) {
            //setAddDriverDialog(true);
            setDriverNameValue({ name: singleTruck.driverName, id: singleTruck.driverId });
        }

    }

    const handleAddDriverDialogClose = () => {
        setAddDriverDialog(false);
        setExpensePaymentMethod('cash')
        if ((singleTruck && singleTruck.driverName) || (requestData && requestData.driverId)) {
            setPaidByDriverValue(true);
        }
        else {
            setPaidByDriverValue(false);
        }
    }

    const handleAddDriverSubmit = (driverIdValue) => {

        let vehicleIdValue = singleTruck.id;

        var data = {
            driverId: driverIdValue
        }

        var dateFilterValueUtil = getTripDateFilterValues();

        var startDateRange = dateFilterValueUtil["ALL_MONTHS"].startDateRange;

        var PandLdata = {
            vehicleId: vehicleIdValue,
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            }
        };

        var expenseData = {
            vehicleId: vehicleIdValue,
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            },
            expenseParentType: []
        };

        let defaultDateFilterValue = "ALL_MONTHS";
        let defaultTripBookFilterValue = "All Trips & Expenses";

        dispatchUpdateVehicleNew(
            vehicleIdValue,
            data,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Add Driver Dialog", "Update Vehicle successfull");
                    setAddDriverDialog(false);
                    setExpensePaymentMethod('paid_by_driver')
                    dispatchGetSingleTruck(vehicleIdValue,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log("Single Vehicle Component Dweb", "Get Single Truck Data Successfull ");
                                dispatchGetPandL(PandLdata, defaultDateFilterValue,
                                    (data) => {
                                        if (data && data.status && data.status.code == 200) {
                                            logger.log("Single Vehicle Component Dweb", "Get P and L report Successfull");
                                            dispatchGetTripExpenses(expenseData, defaultTripBookFilterValue,
                                                (data) => {
                                                    if (data && data.status && data.status.code == 200) {
                                                        logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Successfull");
                                                    }
                                                },
                                                () => {
                                                    logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Failed");
                                                },
                                            )
                                        }
                                    },
                                    () => {
                                        logger.log("Single Vehicle Component Dweb", "Get P and L report Failed");
                                    },
                                )
                            }
                        },
                        () => {
                            logger.log("Single Vehicle Component Dweb", "Get Single Truck Data Failed");
                        }
                    );
                }
            },
            () => {
                logger.log("Add Driver Dialog", "Update Vehicle failed");
            }
        );
    }

    const handleAddExpensePhoto = (file) => {
        var newPhoto = [...addExpensePhoto];
        newPhoto.push({ s3Link: file });
        setAddExpensePhoto(newPhoto);
    }

    const handleDeleteExpensePhoto = (index, attachId) => {
        var newPhoto = [...addExpensePhoto];
        newPhoto.splice(index, 1);
        setAddExpensePhoto(newPhoto);

        if (attachId) {
            dispatchPhotoAttachmentDelete(
                expenseId,
                attachId,
                () => {
                    logger.log("Add Fuel Expense Dialog", "Attachment deleted successfully");
                },
                () => {
                    logger.log("Add Fuel Expense Dialog", "Attachment delete failed");
                },
            )
        }
    }

    const handleExpenseAmount = (value1) => {
        let value = replaceCommas(value1);


        if ((fuelQuantityValue == "" && ratePerLitreValue == "") || (fuelQuantityValue == null && ratePerLitreValue == null)) {
            if (value == '0') {
                setExpenseAmountValue("1");
            } else {
                setExpenseAmountValue(numberWithCommas(Math.round(value)));
            }
        } else if (fuelQuantityValue && ratePerLitreValue) {
            setExpenseAmountValue(numberWithCommas(Math.round(value)));
            if (value > 0) {
                var rpl = (value / fuelQuantityValue).toFixed(2);
                setRatePerLitreValue(rpl);
            } else if (value == 0) {
                setRatePerLitreValue("");
            }
        } else if (value > 0 && fuelQuantityValue) {
            var rpl = (value / fuelQuantityValue).toFixed(2);
            setExpenseAmountValue(numberWithCommas(Math.round(value)));
            setRatePerLitreValue(rpl);
        } else if (value > 0 && (fuelQuantityValue == "" || !fuelQuantityValue) && ratePerLitreValue) {
            var fuelValue = ((value / ratePerLitreValue) % 1) != 0 ? (value / ratePerLitreValue).toFixed(2) : (value / ratePerLitreValue);
            setFuelQuantityValue(fuelValue);
            setExpenseAmountValue(numberWithCommas(Math.round(value)));
        }
        else if (value || value == null) {
            setExpenseAmountValue(numberWithCommas(Math.round(value)));
        }
    }

    const handleFuelQuantity = (value) => {

        var expenseAmount = expenseAmountValue ? replaceCommas(expenseAmountValue) : "";

        if ((expenseAmount == "" || !expenseAmount) && (ratePerLitreValue == "" || !ratePerLitreValue)) {
            if (value == '0') {
                setFuelQuantityValue("1");
            } else {
                setFuelQuantityValue(value);
            }
        } else if (expenseAmount && !ratePerLitreValue && value > 0) {
            var rpl = (expenseAmount / value).toFixed(2);
            setFuelQuantityValue(value);
            setRatePerLitreValue(rpl);
        }
        else if (ratePerLitreValue && !expenseAmount) {
            var expense = value * ratePerLitreValue
            setFuelQuantityValue(value);
            setExpenseAmountValue(expense ? numberWithCommas(Math.round(expense)) : "");
        }
        else if (ratePerLitreValue && expenseAmount) {
            var rpl = value ? (expenseAmount / value).toFixed(2) : "";
            setFuelQuantityValue(value);
            setRatePerLitreValue(rpl);
        }
        else if (expenseAmount && (value == 0 || value == "")) {
            setFuelQuantityValue("");
            setRatePerLitreValue("");
        }
    }

    const handleRatePerLitre = (value1) => {

        let value = value1 ? replaceCommas(value1) : value1;
        let expenseAmount = expenseAmountValue ? replaceCommas(expenseAmountValue) : "";

        if ((expenseAmount == "" && fuelQuantityValue == "") || (!expenseAmount && !fuelQuantityValue)) {
            if (value == '0') {
                setRatePerLitreValue("1");
            } else {
                setRatePerLitreValue(value);
            }
        } else if (fuelQuantityValue && value > 0 && !expenseAmount) {
            var amount = fuelQuantityValue * value;
            setRatePerLitreValue(value);
            setExpenseAmountValue(amount ? numberWithCommas(Math.round(amount)) : "");
        }
        else if (fuelQuantityValue && expenseAmount) {
            var expenseValue = fuelQuantityValue * value;
            setExpenseAmountValue(numberWithCommas(Math.round(expenseValue)));
            setRatePerLitreValue(value);
        }
        else if (fuelQuantityValue && (value == 0 || value == "")) {
            setRatePerLitreValue("");
        }
        else if (ratePerLitreValue == "" || (expenseAmount && value > 0)) {
            setRatePerLitreValue(value);
        }
    }

    return (
        <>
            <Dialog fullWidth={true}
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogOpen} classes={{ paper: classes.paper1 }}>
                <DialogTitle className={classes.dialogTitleV1}>
                    {!edit &&
                        <div className={classes.divV1}>Add Fuel Expense</div>
                    }
                    {edit &&
                        <div className={classes.divV1}>Edit Fuel Expense</div>
                    }

                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Form
                        keepDirtyOnReinitialize
                        onSubmit={onSubmit}
                        initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit;
                            setFormError(isEmpty(validate(values)))
                            return (
                                <form
                                    onSubmit={(event) => {
                                        const promise = handleSubmit(event);
                                        // promise && promise.then(() => {
                                        //     form.reset();
                                        // })
                                        return promise;
                                    }} id="myForm" noValidate>

                                    <div className={classes.titleV1}>Expense Amount*</div>
                                    <AmountInput
                                        placeholder="Enter Amount"
                                        name="amount"
                                        variant="outlined"
                                        size="small"
                                        required={true}
                                        onChange={(e) => handleExpenseAmount(e.target.value)}
                                        fieldProps={{
                                            // parse: value => value && numberWithCommas(value)
                                        }}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">&#x20b9;</InputAdornment>
                                        }}
                                        className={classes.textFieldV1}
                                    />

                                    <div className={classes.divV2}>
                                        <div className={classes.wV1}>
                                            <div className={classes.title}>Fuel Quantity</div>
                                            <TextField
                                                placeholder="Fuel Quantity"
                                                name="fuelQuantity"
                                                variant="outlined"
                                                size="small"
                                                className={classes.marginV1}
                                                onChange={(e) => !isNaN(Number(e.target.value)) ? handleFuelQuantity(e.target.value) : handleFuelQuantity("")}
                                                InputProps={{
                                                    endAdornment: <InputAdornment position="end">L</InputAdornment>
                                                }}
                                            />
                                            <div className={classes.optionText} >Optional</div>
                                        </div>

                                        <div className={classes.divV3}>
                                            <div className={classes.title}>Rate per litre</div>
                                            <TextField
                                                placeholder="Rate per litre"
                                                name="ratePerLitre"
                                                variant="outlined"
                                                size="small"
                                                className={classes.marginV1}
                                                onChange={(e) => !isNaN(Number(e.target.value)) ? handleRatePerLitre(e.target.value) : handleRatePerLitre("")}
                                                // fieldProps={{
                                                //     parse: value => value && numberWithCommas(value)
                                                // }}
                                                InputProps={{
                                                    endAdornment: <InputAdornment position="end">&#x20b9;</InputAdornment>
                                                }}
                                            />
                                            <div className={classes.optionText} >Optional</div>
                                        </div>
                                    </div>

                                    <div className={classes.divV4}>
                                        <div className={classes.divV5}>I have filled full tank</div>
                                        <Switches
                                            size='small'
                                            margin='normal'
                                            formControlProps={{
                                                className: classes.switchControl
                                            }}
                                            // formGroupProps={{}}
                                            // formControlLabelProps={{
                                            //     classes: {
                                            //         root: formClasses.switchLabel
                                            //     },
                                            // }}
                                            className={classes.switch}
                                            name="filledFullTank"
                                            data={{ label: '', value: true }} label="" />
                                    </div>

                                    <div className={classes.marginV1}>
                                        <div className={classes.title}>Current KM Reading</div>
                                        <TextField
                                            placeholder="Current KM Reading"
                                            name="kmReading"
                                            variant="outlined"
                                            size="small"
                                            className={classes.textFieldV1}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">KMs</InputAdornment>
                                            }}
                                        />
                                        <div className={classes.optionText} >Optional</div>
                                    </div>

                                    <div className={classes.marginV2}>
                                        <Grid
                                            container
                                            spacing={1}
                                            direction="row"
                                            justify="flex-start"
                                            alignItems="center"
                                        >
                                            {addExpensePhoto && addExpensePhoto.length > 0 &&
                                                <Grid item>
                                                    <div className="S3Uploader-image-margin">
                                                        {addExpensePhoto && addExpensePhoto.map((expenseImage, index) => (
                                                            <div className="S3Uploader-image-div">
                                                                {expenseImage.s3Link && <img className="S3Uploader-imagesrc" src={expenseImage.s3Link} alt="fileUpload" />}
                                                                <img className="S3Uploader-imageclose" src={require("../../../assets/close-icon.svg")} onClick={() => { handleDeleteExpensePhoto(index, expenseImage.id) }}></img>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Grid>}
                                            <Grid item>
                                                <S3Uploader handleFile={handleAddExpensePhoto} directoryName={"dweb-images/Vehicle/AddFuelExpense"} fromDocumentFlag={true} />
                                            </Grid>
                                        </Grid>
                                    </div>

                                    {/* <div className={classes.marginV2}>
                                        <div className={classes.title}>Payment Method*</div>
                                        <Radios
                                            name="paymentMethod"
                                            required={true}
                                            // formControlProps={{
                                            //     margin: 'none',
                                            //     className: classes.paymentTypeRadio,
                                            //     fullWidth: true
                                            // }}
                                            formControlLabelProps={{
                                                className: classes.paymentTypeLabel
                                            }}
                                            onChange={(e) => { setPaymentType(e.target.value) }}
                                            className={classes.radioV1}
                                            formLabelProps={{}}
                                            radioGroupProps={{ row: true }}
                                            data={[
                                                { value: 'cash', label: 'Cash' },
                                                { value: 'credit', label: 'Credit' },
                                                //{ value: 'Fuel Card', label: 'Fuel Card' },
                                                //{ value: 'UPI', label: 'UPI' },
                                                { value: 'online', label: 'Online' }
                                            ]}
                                        />
                                    </div> */}
                                    <div className={classes.marginV2}>
                                        <div className={classes.title}>Payment Mode*</div>
                                        <Radios
                                            //label="Payment Mode"
                                            name="paymentMethod"
                                            required={true}
                                            formControlProps={{
                                                margin: 'none',
                                                className: classes.billingTypeRadio,
                                                fullWidth: true
                                            }}
                                            formControlLabelProps={{
                                                className: classes.billingTypeLabel
                                            }}
                                            className={classes.mtV2}
                                            onChange={(e) => {
                                                setExpensePaymentMethod(e.target.value)
                                            }}
                                            formLabelProps={{}}
                                            radioGroupProps={{ row: true }}
                                            data={[
                                                { value: 'cash', label: 'Cash' },
                                                { value: 'credit', label: 'Credit' },
                                                { value: 'paid_by_driver', label: 'Paid By Driver' },
                                                { value: 'online', label: 'Online' }
                                            ]}
                                        />
                                    </div>

                                    {values && values.paymentMethod && values.paymentMethod == 'credit' ? <div className={classes.marginV2}>
                                        <div className={classes.title}>Shop*</div>
                                        <Autocomplete
                                            required={true}
                                            id="search-shop-input"
                                            onOpen={() => {
                                                fetchShops()
                                            }}
                                            getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                                            options={shops}
                                            autoComplete
                                            name="shop"
                                            // open={true}
                                            //includeInputInList
                                            className={classes.textFieldV1}
                                            filterSelectedOptions
                                            size="small"
                                            //disableClearable
                                            value={expenseShop}
                                            getOptionSelected={(option, value) => option.id === value.id}
                                            onChange={(event, newValue) => {
                                                if (typeof newValue === 'string') {
                                                    // timeout to avoid instant validation of the dialog's form.
                                                    setTimeout(() => {
                                                        setExpenseShop('');
                                                        toggleAddShopOpen(true);
                                                        setShopDialogValue({
                                                            name: newValue ? newValue : "",
                                                        });
                                                    });
                                                } else if (newValue && newValue.inputValue) {
                                                    setExpenseShop(null);
                                                    toggleAddShopOpen(true);
                                                    setShopDialogValue({
                                                        name: newValue.inputValue ? newValue.inputValue : "",
                                                    });
                                                } else if (newValue && newValue.inputValue === '') {
                                                    setExpenseShop('');
                                                    toggleAddShopOpen(true);
                                                    setShopDialogValue({
                                                        name: "",
                                                    });
                                                } else {
                                                    setExpenseShop(newValue && newValue.id ? newValue : null);
                                                }
                                            }}
                                            filterOptions={(options, params) => {
                                                let filtered = []
                                                options.forEach((item, index) => {
                                                    filtered.push({
                                                        ...item,
                                                        index: index
                                                    })
                                                });
                                                filtered.unshift({
                                                    inputValue: params.inputValue,
                                                    name: params.inputValue && params.inputValue.length > 1 ? `Add "${params.inputValue}" as shop` : `Add New Shop`,
                                                    add: true
                                                });
                                                return filtered;
                                            }}
                                            clearOnBlur
                                            multiple={false}
                                            getOptionValue={option => option}
                                            getOptionLabel={(option) => {
                                                // e.g value selected with enter, right from the input
                                                if (typeof option === 'string') {
                                                    return '';
                                                }
                                                if (option.inputValue || !option.id) {
                                                    return '';
                                                }
                                                return option && option.name ? option.name : ''
                                            }}
                                            onInputChange={(event, newInputValue) => {
                                                setShopInputValue(newInputValue);
                                                onSearchBlur(newInputValue, false)
                                            }}
                                            classes={
                                                {
                                                    option: classes.shopOption,
                                                    listbox: classes.listBoxV1,
                                                    paper: classes.autoCompletePaper
                                                }
                                            }
                                            textFieldProps={
                                                {
                                                    //label: "Shop",
                                                    placeholder: "Search and select shop",
                                                    variant: "outlined",
                                                    //margin: 'normal',
                                                }
                                            }
                                            renderOption={(option, { selected, inputValue }) => {
                                                let matchesName, matchesNumber;
                                                let partsName, partsNumber;
                                                matchesName = match(option.name, inputValue);
                                                partsName = parse(option.name, matchesName);
                                                matchesNumber = match(option.contactNumber, inputValue);
                                                partsNumber = parse(option.contactNumber, matchesNumber);

                                                if (option && option.id) {
                                                    if (option.index == shops.length - 1) {
                                                        return (
                                                            <Fragment>
                                                                <Waypoint
                                                                    onEnter={() => {
                                                                        if (!shopInputValue && shopsListData && shopsListData.maxPage && shopsListData.maxPage != currentPageNo) {
                                                                            setCurrentPageNo(currentPageNo + 1)
                                                                            fetchShops(option.inputValue, true)
                                                                        }
                                                                    }}
                                                                />
                                                                <div className={classes.shopListItem}>
                                                                    {partsName.map((part, index) => {
                                                                        return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                                                                            {part.text}
                                                                        </span>
                                                                        )
                                                                    })}
                                                                    {option.contactNumber && <>
                                                                        <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                                                                        {partsNumber.map((part, index) => {
                                                                            return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                                                                                {part.text ? (part.text).replace(/(\d{5})(\d{5})/, "$1-$2") : ""}
                                                                            </span>
                                                                            )
                                                                        })}
                                                                    </>}
                                                                </div>
                                                            </Fragment>
                                                        );
                                                    } else {
                                                        return (
                                                            <div className={classes.shopListItem}>
                                                                {partsName.map((part, index) => {
                                                                    return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                                                                        {part.text}
                                                                    </span>
                                                                    )
                                                                })}
                                                                {option.contactNumber && <>
                                                                    <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                                                                    {partsNumber.map((part, index) => {
                                                                        return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                                                                            {part.text ? (part.text).replace(/(\d{5})(\d{5})/, "$1-$2") : ""}
                                                                        </span>
                                                                        )
                                                                    })}
                                                                </>}
                                                            </div>
                                                        );
                                                    }
                                                } else {
                                                    return (
                                                        <div className={classes.shopListItem1}>
                                                            <AddPersonIcon className={classes.addPersonIcon} />
                                                            {partsName.map((part, index) => {
                                                                return (<span key={index} style={{ color: index == 1 ? 'black' : '#5170f0' }}>
                                                                    {part.text}
                                                                </span>
                                                                )
                                                            })}
                                                            <ChevronRightIcon className={classes.cherveRightIconV1} />
                                                        </div>
                                                    );
                                                }

                                            }}
                                        />
                                    </div> : ""}
                                    {values && values.paymentMethod && values.paymentMethod == 'online' ? <div className={classes.marginV2}>
                                        <div className={classes.title}>Transaction ID</div>
                                        <TextField
                                            //label={'Transaction ID'}
                                            placeholder="Transaction ID"
                                            name="transactionId"
                                            variant="outlined"
                                            size="small"
                                            //margin="normal"
                                            className={classes.textFieldV1}
                                            onChange={(e) => { setExpenseTransactionId(e.target.value) }}
                                        />
                                    </div> : ''
                                    }
                                    {
                                        values && values.paymentMethod && values.paymentMethod == 'paid_by_driver' ? <div className={classes.marginV2}>
                                            <div className={classes.title}>Driver</div>
                                            <TextField
                                                placeholder="Driver"
                                                name="selectedDriver"
                                                variant="outlined"
                                                disabled
                                                value={
                                                    requestData && requestData.driverId ? requestData.driverName : singleTruck && singleTruck.driverId && singleTruck.driverName ? singleTruck.driverName : ''
                                                }
                                                size="small"
                                                //onClick={()=>{setAddDriverDialog(true);}}
                                                className={classes.textFieldV1}
                                            />
                                        </div> : ''}
                                    <div className={classes.marginV2}>
                                        <div className={classes.title}>Expense Date*</div>
                                        <DatePicker
                                            disableFuture
                                            name="expenseDate"
                                            margin="none"
                                            variant="inline"
                                            fullWidth={true}
                                            // onChange={(date) => { setTripStartDate(date) }}
                                            inputVariant="outlined"
                                            size="small"
                                            format="dd-MM-yyyy"
                                            placeholder="Select Date"
                                            dateFunsUtils={DateFnsUtils}
                                            required={true}
                                            className={classes.textFieldV1}
                                            InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                                        />
                                    </div>

                                    <div className={classes.marginV2}>
                                        <div className={classes.title}>Diesel Pump Name</div>
                                        <TextField
                                            placeholder="Diesel Pump Name"
                                            name="dieselPumpName"
                                            variant="outlined"
                                            size="small"
                                            className={classes.textFieldV1}

                                        />
                                        <div className={classes.optionText} >Optional</div>
                                    </div>

                                    {/* <div className={classes.divV4}>
                                        <div className={classes.divV5}>Paid by {singleTruck && singleTruck.driverId && singleTruck.driverName ? singleTruck.driverName : 'Driver'}</div>
                                        <Switches
                                            size='small'
                                            margin='normal'
                                            formControlProps={{
                                                className: classes.switchControl
                                            }}
                                            // formGroupProps={{}}
                                            // formControlLabelProps={{
                                            //     classes: {
                                            //         root: formClasses.switchLabel
                                            //     },
                                            // }}
                                            onChange={() => { handlePaidByDriver() }}
                                            className={classes.switch}
                                            name="paidByDriver"
                                            data={{ label: '', value: true }} label="" />
                                    </div> */}

                                </form >
                            )
                        }}
                    />
                </DialogContent >
                <Divider className={classes.marginV3} />
                <DialogActions className={classes.da1}>
                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()} >
                        Close
                    </Button>
                    <Button
                        className={!formError ? classes.disableCta : classes.saveCta}
                        disabled={!formError}
                        type="submit" variant="contained"
                        // onClick={() => {
                        //     document.getElementById('myForm')
                        //         .dispatchEvent(new Event('submit', { cancelable: true }))
                        // }}
                        onClick={event => {
                            submit(event)
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog >

            {addDriverDialog && <DriverNameSelect onOpen={addDriverDialog} onClose={handleAddDriverDialogClose} fromSingleTruck={true} onConfirm={handleAddDriverSubmit} driverDetail={driverNameValue} />}
            {addShopOpen && <AddShop open={addShopOpen} defaultName={shopDialogValue.name} defaultNumber={shopDialogValue.number} onClose={handleAddShopClose} onSave={handleShopSave} />}
        </>
    )

}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchUpdateVehicleNew: (vehicleId, data, onSuccess, onFailure) => {
        dispatch(
            updateVehicle3(vehicleId, data, onSuccess, onFailure))
    },
    dispatchPhotoAttachmentDelete: (expenseId, attachId, onSuccess, onFailure) => dispatch(DeletePhotoAttachments(expenseId, attachId, onSuccess, onFailure)),
    dispatchUpdateExpenseDetails: (expenseId, data, onSuccess, onFailure) => dispatch(UpdateExpenseDetails(expenseId, data, onSuccess, onFailure)),
    dispacthAddExpenses: (data, onSuccess, onFailure) => dispatch(addVendorExpense(data, onSuccess, onFailure)),
    dispatchGetSingleTruck: (truckId, onSuccess, onFailure) => dispatch(singleTruck(truckId, onSuccess, onFailure)),
    dispatchGetPandL: (data, defaultDateFilterValue, onSuccess, onFailure) => dispatch(PandL(data, defaultDateFilterValue, onSuccess, onFailure)),
    dispatchGetTripExpenses: (data, defaultTripBookFilterValue, onSuccess, onFailure) => dispatch(Expenses(data, defaultTripBookFilterValue, onSuccess, onFailure)),
    dispatchAddExpenseV1: (request, onSuccess, onFailure) =>
        dispatch(addExpenseV1(request, onSuccess, onFailure)),
    dispatchGetShopList: (data, onSuccess, onError) => {
        dispatch(shopListForSelection(data, onSuccess, onError))
    },
    dispatchEditExpenseV1: (expenseId, request, onSuccess, onFailure) =>
        dispatch(editExpenseV1(expenseId, request, onSuccess, onFailure))
});

export default connect(mapStateToProps, mapDispatchToProps)(AddFuelExpenseDialog);
